<script>
import { USER_SETTINGS } from '../graphql/queries/UserQueries'
import { updateUser } from '../services/userService'
import DemographicsForm from '../components/globals/DemographicsForm'
import { ContentLoader } from 'vue-content-loader'
import { isMobile } from 'mobile-device-detect'

const defaultErrors = {
  firstName: null,
  lastName: null,
  email: null,
  gender: null,
  height: null,
  weight: null
}

export default {
  name: 'SettingsView',
  components: { DemographicsForm, ContentLoader },
  data() {
    return {
      userForm: {
        gender: null,
        birthDate: new Date(1990, 1, 1),
        height: null,
        weight: null,
        unitHeight: 'cm',
        unitWeight: 'kg'
      },
      loading: false,
      errors: { ...defaultErrors },
      isMobile: isMobile
    }
  },
  apollo: {
    userForm: {
      query: USER_SETTINGS,
      update: data => ({
        ..._.omit(data.myUser, ['__typename']),
        birthDate: new Date(data.myUser.birthDate)
      })
    }
  },
  methods: {
    successMessage() {
      this.$snackbar.open({
        message: 'Settings updated',
        type: 'is-secondary',
        position: 'is-bottom-left'
      })
    },
    async saveProfile() {
      this.errors = { ...defaultErrors }
      if (!this.userForm.firstName)
        return (this.errors.firstName = 'Enter your first name.')
      if (!this.userForm.lastName)
        return (this.errors.lastName = 'Enter your last name.')
      if (!this.userForm.email) return (this.errors.email = 'Enter your email.')
      if (!this.userForm.gender)
        return (this.errors.gender = 'Select your gender.')
      if (!this.userForm.height)
        return (this.errors.height = 'Enter your height.')
      if (!this.userForm.weight)
        return (this.errors.weight = 'Enter your weight.')

      try {
        this.loading = true

        await updateUser({
          ...this.userForm,
          height: Number.parseFloat(this.userForm.height),
          weight: Number.parseFloat(this.userForm.weight)
        })

        this.loading = false
        this.successMessage()
      } catch ({ message }) {
        this.loading = false

        if (message.includes('Error, expected `email` to be unique'))
          this.errors.email = 'Email is already taken'

        if (message.includes('Email is not valid'))
          this.errors.email = 'Email is not valid'
      }
    }
  }
}
</script>

<template>
  <div class="section container account-view">
    <ContentLoader
      v-if="$apollo.loading"
      :height="150"
      :width="isMobile ? 200 : 400"
      :speed="3"
    >
      <rect x="0" y="0" rx="3" ry="3" width="155" height="12" />
      <rect x="0" y="20" rx="3" ry="3" width="350" height="4" />
      <rect x="0" y="30" rx="3" ry="3" width="380" height="4" />
      <rect x="0" y="40" rx="3" ry="3" width="201" height="4" />
    </ContentLoader>

    <div v-if="!$apollo.loading" class="container column is-three-fifths">
      <!-- Contact -->
      <h2 class="title">Contact</h2>
      <div class="columns">
        <!-- First Name -->
        <div class="column is-half">
          <b-field
            label="First name"
            :type="{ 'is-danger': !!errors.firstName }"
            :message="errors.firstName"
          >
            <b-input v-model="userForm.firstName" type="text" />
          </b-field>
        </div>
        <!-- Last Name -->
        <div class="column is-half">
          <b-field
            label="Last name"
            :type="{ 'is-danger': !!errors.lastName }"
            :message="errors.lastName"
          >
            <b-input v-model="userForm.lastName" type="text" />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <!-- Email -->
        <div class="column">
          <b-field
            label="Email"
            :type="{ 'is-danger': !!errors.email }"
            :message="errors.email"
          >
            <b-input v-model="userForm.email" type="text" />
          </b-field>
        </div>
      </div>

      <DemographicsForm :user-form="userForm" :errors="errors" />

      <!-- Save Profile -->
      <div class="columns">
        <div class="column">
          <b-button
            type="is-secondary"
            class="is-pulled-right"
            @click="saveProfile"
            rounded
            :loading="loading"
          >
            Save profile
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="sass">
.step
  width: 45%
</style>
